import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { handleResponseCode } from "../../../../app/utilities/helpers";
import Cookies from "universal-cookie";
import GetProxy from "../../../../app/GetProxy";

const proxy  = GetProxy();


const cookies = new Cookies();

export const StateCategorizationList = createAsyncThunk(
    "get/StateCategorizationList",
    async (props) => {
      const apiToken = cookies.get("apitoken");
      const username = cookies.get("username");
      try {
        const response = await fetch(`${proxy}/aws/api/v1/architectureCompliance/getConfigState`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
        }
        );
        handleResponseCode(response);
        const data = await response.json();
       
  
        return response.ok ? data : Promise.reject(data);
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    }
  );

  export const saveStateCategorization = createAsyncThunk(
    "post/saveStateCategorization",
    async (props) => {
      const apiToken = cookies.get("apitoken");
      const username = cookies.get("username");
      try {
        const { payload } = props;
        const response = await fetch(`${proxy}/aws/api/v1/architectureCompliance/saveConfigState`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload)
        }
        );
        handleResponseCode(response);
        const data = await response.json();
         
        return response.ok ? data : Promise.reject(data);
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    }
  );

  const stateSlice = createSlice({
    name:'statePrivilege',
    initialState:{
       StateCatgorizeLoading:false,
       StateCategorizationListData:{},
       savestateLoading:false,
       savePolicyCategorizationData:{}
    },
    extraReducers: (builder) => {
        builder
          //StateCatgorizeList
          .addCase(StateCategorizationList.pending, (state, action) => {
            state.StateCatgorizeLoading = true;
          })
          .addCase(StateCategorizationList.fulfilled, (state, action) => {
            state.StateCategorizationListData = action.payload;
            state.StateCatgorizeLoading = false;
          })
          .addCase(StateCategorizationList.rejected, (state, action) => {
            state.StateCatgorizeLoading = false;
          })

          //saveStateCategorization
          .addCase(saveStateCategorization.pending, (state, action) => {
            state.savestateLoading = true;
          })
          .addCase(saveStateCategorization.fulfilled, (state, action) => {
            state.savePolicyCategorizationData = action.payload;
            state.savestateLoading = false;
          })
          .addCase(saveStateCategorization.rejected, (state, action) => {
            state.savestateLoading = false;
          });
    
      }
  });

  export default stateSlice.reducer;
  